import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SHOPIFY_URL } from '../constants';
export const StickyCTA: React.FC = () => <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 pt-3" style={{
  background: 'linear-gradient(180deg, transparent, rgba(10,17,40,0.92) 25%, rgba(10,17,40,0.98) 100%)',
  backdropFilter: 'blur(8px)',
  paddingBottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))'
}} data-id="element-471">
    <a href={SHOPIFY_URL} className="btn-gold w-full py-4 rounded-full flex items-center justify-center gap-2 text-sm tracking-wide" data-id="element-472">
      Obtener el libro ahora
      <ArrowRightIcon className="w-4 h-4" strokeWidth={2} data-id="element-473" />
    </a>
  </div>;